import React from "react";
import { Output } from "../../Text";
import {
  Spinner,
  ContentSection,
  Layout,
  SectionHeading,
  Paragraph,
} from "@vwfs-bronson/bronson-react";
import { TileSelect } from "../../components/TitleSelect";
import { Analytics } from "../../services/analytics";
import { setActualPage } from "../page.utils";

class CheckoutSelectPage extends React.Component<
  CheckoutSelectProps,
  CheckoutSelectState
> {
  constructor(props: CheckoutSelectProps) {
    super(props);

    this.state = {
      showSpinner: false,
    };
  }

  pageName = "DAC Selection";

  defaultTrackingData = {
    [Analytics.keys.pageName()]: this.pageName,
    [Analytics.keys.viewChange()]: this.pageName,
  };

  trackPage = () => {
    setTimeout(() => {
      const checkoutSelectData = {
        [Analytics.keys.eventType(0)]: "pageView",
        [Analytics.keys.eventAction(0)]: "Success",
        [Analytics.keys.eventType(1)]: "Product journey",
        [Analytics.keys.eventAction(1)]: "Start",
        [Analytics.keys.eventType(2)]: "Product configuration",
        [Analytics.keys.eventAction(2)]: "Completed",
        [Analytics.keys.eventType(3)]: "Product price",
        [Analytics.keys.eventAction(3)]: "Calculated",
      };
      Analytics.setTrackingData({
        ...this.defaultTrackingData,
        ...checkoutSelectData,
      });
      Analytics.trackPage();
    }, 1000);
  };

  trackSuccessDAC = () => {
    const succesDACData = {
      [Analytics.keys.eventType(0)]: "interAction",
      [Analytics.keys.eventAction(0)]: "Success",
      [Analytics.keys.linkInformation(0)]: "User choice: DAC",
    };
    Analytics.setTrackingData({
      ...this.defaultTrackingData,
      ...succesDACData,
    });
    Analytics.trackInteraction();
  };

  trackSuccessManual = () => {
    const succesManualData = {
      [Analytics.keys.eventType(0)]: "interAction",
      [Analytics.keys.eventAction(0)]: "Success",
      [Analytics.keys.linkInformation(0)]: "User choice: Manual data entry",
    };
    Analytics.setTrackingData({
      ...this.defaultTrackingData,
      ...succesManualData,
    });
    Analytics.trackInteraction();
  };

  componentDidMount() {
    setActualPage(this.pageName);
    this.trackPage();
  }
  enableSpinner() {
    this.setState({ showSpinner: true });
  }
  render() {
    return (
      // TODO <ShoppingCart />
      <>
        {this.state.showSpinner && <Spinner fullPage />};
        <div className="o-page-wrap o-page-wrap--medium">
          <ContentSection>
            <SectionHeading
              level="1"
              subtitle={Output.resolve("pages.leasing.checkoutSelect.subtitle")}
              center
              primary
            >
              {Output.resolve("pages.leasing.checkoutSelect.title")}
            </SectionHeading>
            <Paragraph className="u-text-center">
              {Output.resolve("pages.leasing.checkoutSelect.options")}
            </Paragraph>
            <Layout className="o-layout--equal-height">
              <Layout.Item default="1/2">
                <TileSelect
                  id="dacTile"
                  title={Output.resolve(
                    "pages.leasing.checkoutSelect.dac.title"
                  )}
                  txtBody={
                    Output.resolve(
                      "pages.leasing.checkoutSelect.dac.subtitle"
                    ) +
                    " " +
                    Output.resolve("pages.leasing.checkoutSelect.dac.body")
                  }
                  txtButton={Output.resolve(
                    "pages.leasing.checkoutSelect.common.button"
                  )}
                  onClick={() => {
                    this.enableSpinner();
                    const successCallback = () => {
                      this.trackSuccessDAC();
                    };
                    this.props.onDAC(successCallback);
                  }}
                />
              </Layout.Item>

              <Layout.Item default="1/2">
                <TileSelect
                  id="manualTile"
                  title={Output.resolve(
                    "pages.leasing.checkoutSelect.manual.title"
                  )}
                  txtBody={
                    Output.resolve(
                      "pages.leasing.checkoutSelect.manual.subtitle"
                    ) +
                    " " +
                    Output.resolve("pages.leasing.checkoutSelect.manual.body")
                  }
                  txtButton={Output.resolve(
                    "pages.leasing.checkoutSelect.common.button"
                  )}
                  onClick={() => {
                    this.enableSpinner();
                    const successCallback = () => {
                      this.trackSuccessManual();
                    };
                    this.props.onManual(successCallback);
                  }}
                />
              </Layout.Item>
            </Layout>
          </ContentSection>
        </div>
      </>
    );
  }
}

type CheckoutSelectProps = {
  onManual: Function;
  onDAC: Function;
};
type CheckoutSelectState = {
  showSpinner: boolean;
};
export { CheckoutSelectPage };